import React, { useState } from 'react';
import { IDropdownItem } from '../ManageModularMember/types';
import { validatePhoneNumber } from '../../../utils/common';
import { setPurchaseAttributes } from '../../../redux/slices/ModularEnrolmentSlice';
import { ReduxState } from '../../../redux';
import { useSelector } from 'react-redux';
import { FlagsmithFlags, useFeatureFlag } from '../../../utils/flagsmith';
import PurchaseAttributesStep1 from './PurchaseAttributesStep1';
import PurchaseAttributesStep2 from './PurchaseAttributesStep2';
const PurchaseAttributePerLifeModal = ({
    plan,
    planIds,
    values,
    setValues,
    members,
    uncoveredText,
    step,
    purchaseAttributes,
    formValues,
    setFormValues,
    setShowError
}) => {
    const isPurchaseAttributesEnabled = useFeatureFlag(FlagsmithFlags.PURCHASE_ATTRIBUTES);
    const hasPurchaseAttributes = isPurchaseAttributesEnabled
        ? Object.keys(plan.purchaseAttributes ?? {}).length > 0
        : false;
    const [errorStatus, setErrorStatus] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const selectedPurchaseAttributes = useSelector((state: ReduxState) => state.modular.purchaseAttributes) ?? {};
    const handleCheckboxChange = (id: string, checked: boolean, dropdownOptions: IDropdownItem[]) => {
        let value = values[id]?.value;
        if (checked && dropdownOptions.length === 1 && !value) value = dropdownOptions[0].value;
        if (!checked && formValues?.[id]) delete formValues[id];
        setValues((prev) => ({ ...prev, [id]: { value, checked } }));
    };
    const flushPurchaseAttributes = (value: string, id: string, planIds: string[]) => {
        const updatedAttributes = JSON.parse(JSON.stringify(selectedPurchaseAttributes ?? {}));
        planIds.forEach((planId) => {
            if (
                updatedAttributes[planId] &&
                typeof updatedAttributes[planId] === 'object' &&
                updatedAttributes[planId][id] !== undefined
            ) {
                delete updatedAttributes[planId][id];
                if (Object.keys(updatedAttributes[planId]).length === 0) {
                    delete updatedAttributes[planId];
                }
            }
        });
        setPurchaseAttributes(updatedAttributes);
    };


    const handleFormChange = (fieldKey: string, value: string, userId: string, category: string) => {
        switch (category?.toLocaleLowerCase()) {
        case 'mobile':
            if (!validatePhoneNumber(value)) {
                setShowError(true);
                setErrorStatus(true);
                setErrorMessage('Invalid mobile number');
            } else {
                setShowError(false);
                setErrorMessage('');
            }
            break;
        default:
            break;
        }
        setFormValues((prev) => ({
            ...prev,
            [userId]: {
                ...prev[userId],
                [fieldKey]: value
            }
        }));
    };

    const handleOnDropdownChange = (id: string, value: string) => {
        // flush the purchase attributes for the member
        flushPurchaseAttributes(value, id, planIds);
        setValues((prev) => ({ ...prev, [id]: { checked: true, value } }));
    };


    return step === 1 ? (
        <PurchaseAttributesStep1
            plan={plan}
            planIds={planIds}
            values={values}
            setValues={setValues}
            members={members}
            uncoveredText={uncoveredText}
            hasPurchaseAttributes={hasPurchaseAttributes}
            handleCheckboxChange={handleCheckboxChange}
            handleOnDropdownChange={handleOnDropdownChange}
        />
    ) : (
        <PurchaseAttributesStep2
            values={values}
            members={members}
            purchaseAttributes={purchaseAttributes}
            formValues={formValues}
            setFormValues={setFormValues}
            handleFormChange={handleFormChange}
            errorStatus={errorStatus}
            errorMessage={errorMessage}
        />
    );
};

export default PurchaseAttributePerLifeModal;
